module.exports = __webpack_public_path__ + "img/V19-bg.915c61d6.png";